import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { Card, CardHeader, CardContent, IconButton, Tooltip } from "@mui/material";

import { BasicFlex, LabelUpper } from "../../../utils/Common";

import { capitalize, startCase } from "lodash";


// customer info icons
import AccountBoxOutlinedIcon from '@mui/icons-material/AccountBoxOutlined';
import AccountBoxRoundedIcon from '@mui/icons-material/AccountBoxRounded';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import PlaceRoundedIcon from '@mui/icons-material/PlaceRounded';
import SubdirectoryArrowRightRoundedIcon from '@mui/icons-material/SubdirectoryArrowRightRounded';
import SupportAgentRoundedIcon from '@mui/icons-material/SupportAgentRounded';

// invoice info icons
import ReceiptRoundedIcon from '@mui/icons-material/ReceiptRounded';
import PendingActionsRoundedIcon from '@mui/icons-material/PendingActionsRounded';

/// actions icons
import PrintRoundedIcon from '@mui/icons-material/PrintRounded';
import AttachEmailRoundedIcon from '@mui/icons-material/AttachEmailRounded';
import ShareRoundedIcon from '@mui/icons-material/ShareRounded';


import { formatGenericDate, formatCurrency, formatPhoneNumber, displayTruncated } from "../../../utils/util";

import ShareButton from "../../../utils/utilities/Buttons/ShareButton";
// download button
import DownloadButton from "../../../utils/utilities/Buttons/DownloadButton";

const InvoiceContainer = styled(BasicFlex)`
  border: 2px dotted ${props => props.theme.colors.border};
  flex-direction: column;
  padding: 2rem;
  border-radius: 5px;
  background-color: white;
`;

const ActionBar = styled(BasicFlex)`
  justify-content: flex-end;
  gap: 1rem;
`;

const InfoBar = styled(BasicFlex)`

`

const InfoLabel = styled.div`
  font-weight: 500;
  text-transform: uppercase;
  color: ${props => props.theme.colors.mildText};
  margin-bottom: 1rem;
`

const CustomerInfo = styled(BasicFlex)`
  flex-direction: column;
  align-items: flex-start;
`;

const CustomerInfoLines = styled(BasicFlex)`
  justify-content: flex-start;
  gap: .8rem;
  margin: .4rem 0;
  /* font-weight: 500; */
  font-style: italic;
  line-height: ${props => props.$multiline ? '2.2rem' : 'normal'};
`;

const DateInfo = styled(BasicFlex)`
  flex-direction: column;
  align-items: flex-start;

`;

const DateInfoLines = styled(BasicFlex)`
  justify-content: flex-start;
  gap: .8rem;
  margin: .6rem 0;
  /* font-weight: 500; */

  .header {
    font-weight: 500;
  }

  .info {

  }
`;

const LineItemsContainer = styled.div`
  margin-top: 5rem;
  width: 100%;

  @media ${props => props.theme.breaks.down('lg')} {
    overflow-x: scroll;
    width: 100%;
  }
`;

const LineItemsSection = styled(BasicFlex)`
  flex-direction: column;
  align-items: flex-start;

  @media ${props => props.theme.breaks.down('lg')} {
    min-width: max-content;
  }
`;

/* main bill display */
  const HeaderLines = styled(BasicFlex)`
    justify-content: space-between;
    border-top: 2px solid ${props => props.theme.colors.darkBg};
    border-bottom: 2px solid ${props => props.theme.colors.darkBg};
  `;

  const HeaderItem = styled.div`
    background-color: ${props => props.theme.colors.darkBg};
    padding: 1rem 2rem;
    margin: .2rem 0;
    font-weight: 500;
    flex-basis: 0;
    flex-grow: 1;
    text-align: ${props => props.align || "center"};
  `

  const RepairLabel = styled(LabelUpper)`
    margin: .3rem 0;
  `

  const LineItemRow = styled(BasicFlex)`
    border-bottom: 1px solid ${props => props.theme.colors.border};
    justify-content: space-between;
    margin-top: .8rem;
    
    ${props => props.$noBorder ? css/* closed */`
    border: none;
    ` : ''}
  `

  const SubLineItemRow = styled(LineItemRow)`
    color: ${props => props.theme.colors.mildText};
    font-style: italic;
    font-weight: 500;
    margin-top: .1rem;
    border: none;

    ${props => props.$last ? css/* closed */`
      border-bottom: 1px solid ${props.theme.colors.border} !important;
      padding-bottom: .4rem;
    ` : ''}
  `

  const LineItem = styled.div`
    flex-basis: 0;
    flex-grow: 1;
    padding: .8rem 2rem;
    text-align: ${props => props.align || "center"};
  `

  const SubLine = styled.div`
    padding: .4rem 1rem;
    font-weight: normal;
  `
/* end main bill display */

const SummarySection = styled(BasicFlex)`
  background-color: ${props => props.theme.colors.darkBg};
  margin-top: 1rem;
  border-radius: 5px;
  padding: 2rem 4rem;
  text-transform: uppercase;
  font-weight: 500;

  .amount {
    width: 10rem;
    text-align: right;
  }
`;

const InvoiceDisplay = ({invoice = {}}) => {

  console.log(invoice);

  let customer = invoice?.customer || {}

  let line_items = invoice?.line_items || [];

  let adjustments = line_items.filter(el => el.item_type === "charge" || el.item_type === "discount");

  let adjustmentTotal = 0;
  adjustments.forEach(el => {
    if (el.item_type === "charge") {
      adjustmentTotal += el.calculated_amount;
    } else {
      adjustmentTotal -= el.calculated_amount;
    }
  })

  line_items = line_items.filter(li => {
    let returned = ["service", "product", "inventory", "custom_order"];
    if (returned.includes(li.item_type)) return true;
    if (li.item_type === "repair") {
      let findWig = line_items.find(wig => wig.item_type === "inventory" && wig.name === li.wig_id);
      if (findWig) return false;
      return true;
    }
    return false;
  })

  return (
    <InvoiceContainer>
      <ActionBar>
       {/* <ShareButton apiUrl={`/invoices/generate/${invoice.invoice_id}`} />
       <DownloadButton url={`/invoices/generate/${invoice.invoice_id}`} />
       <Tooltip title="Attach PDF To Email"><IconButton size="small" color="secondary"><AttachEmailRoundedIcon /></IconButton></Tooltip> */}
      </ActionBar>
      <InfoBar>
        <CustomerInfo>
          <InfoLabel>Bill To</InfoLabel>
          <CustomerInfoLines><AccountBoxRoundedIcon color="basic" fontSize="small" />{customer.full_name}</CustomerInfoLines>
          <CustomerInfoLines align="flex-start" $multiline><PlaceRoundedIcon color="basic" fontSize="small" />{customer.address} <br/>{customer.city ? `${customer.city}, ` : ''} {customer.state ? `${customer.state}, ` : ''} {customer.zip ? `${customer.zip}` : ''}</CustomerInfoLines>
          <CustomerInfoLines><PhoneOutlinedIcon color="basic" fontSize="small" />{formatPhoneNumber(customer.mobile_phone)}</CustomerInfoLines>
          <CustomerInfoLines><EmailOutlinedIcon color="basic" fontSize="small" />{customer.email}</CustomerInfoLines>
          </CustomerInfo>
        <DateInfo>
          {/* <InfoLabel>Invoice Info</InfoLabel> */}
          <DateInfoLines><ReceiptRoundedIcon color="basic" fontSize="small" /> <span className="header">Invoice #:</span> <span className="info">{invoice.invoice_num}</span></DateInfoLines>
          <DateInfoLines><CalendarMonthRoundedIcon color="basic" fontSize="small" /> <span className="header">Date:</span> <span className="info">{formatGenericDate(invoice.date)}</span></DateInfoLines>
          <DateInfoLines><PendingActionsRoundedIcon color="basic" fontSize="small" /> <span className="header">Due Date:</span> <span className="info">{formatGenericDate(invoice.due_date)}</span></DateInfoLines>
          <DateInfoLines><SupportAgentRoundedIcon color="basic" fontSize="small" /> <span className="header">Sales Rep:</span> <span className="info">{invoice.sales_rep}</span></DateInfoLines>
        </DateInfo>
      </InfoBar>

      <LineItemsContainer>
      <LineItemsSection>
        <HeaderLines>
          <HeaderItem align="left">Name</HeaderItem>
          <HeaderItem align="left">Item Type</HeaderItem>
          <HeaderItem align="left">Description</HeaderItem>
          <HeaderItem align="right">Qty</HeaderItem>
          <HeaderItem align="right">Price</HeaderItem>
          <HeaderItem align="right">Total</HeaderItem>
        </HeaderLines>
        
        {line_items?.map((item, index) => {
          let repairs = item.item_type === "inventory" ? invoice?.line_items?.filter(li => li.item_type === "repair" && li.wig_id === item.name) : [];

          return (
          <>
            <LineItemRow key={item.name} $noBorder={repairs?.length}>
              <LineItem align="left">{item.name}</LineItem>
              <LineItem align="left">{startCase(item.item_type)}</LineItem>
              <LineItem align="left">{displayTruncated(item.description, {length: 30})}</LineItem>
              <LineItem align="right">{item.quantity}</LineItem>
              <LineItem align="right">{formatCurrency(item.rate)}</LineItem>
              <LineItem align="right">{formatCurrency(item.calculated_amount)}</LineItem>
            </LineItemRow>
            {/* <RepairLabel $light $size="1.2rem" $normal>Repairs</RepairLabel> */}
            {repairs?.map((repair, ind) => (
              <SubLineItemRow key={repair.name} $last={ind === repairs.length - 1}>
                <SubLine>
                <BasicFlex justify="flex-start" gap="1rem">
                  <SubdirectoryArrowRightRoundedIcon fontSize="small" color="icon" />
                  <div>{repair.name}</div>
                  <div>&middot;</div>
                  <div>{repair.duration}</div>
                </BasicFlex>
                </SubLine>
                <SubLine>{formatCurrency(repair.calculated_amount)}</SubLine>
              </SubLineItemRow>
            ))}
          </>
        )}
        )}

          {adjustments?.map((item, index) => {
              let rate = item.item_type === "discount" ? -item.rate : item.rate;
              rate = item.rate_type === "fixed" ? formatCurrency(rate) : `${rate}%`;
              let calculated = item.item_type === "discount" ? -item.calculated_amount : item.calculated_amount;
              return (
              <>
                <LineItemRow key={item.name}>
                  <LineItem align="left">{item.name}</LineItem>
                  <LineItem align="left">{capitalize(item.item_type)}</LineItem>
                  <LineItem align="left">{displayTruncated(item.description, {length: 15})}</LineItem>
                  <LineItem align="right">{item.quantity}</LineItem>
                  <LineItem align="right">{rate}</LineItem>
                  <LineItem align="right">{formatCurrency(calculated)}</LineItem>
                </LineItemRow>
              </>
            )}
            )}

      </LineItemsSection>
      </LineItemsContainer>


      <SummarySection dir="column" gap="1.6rem">
        <BasicFlex justify="flex-end" gap="2rem"><div>Subtotal:</div><div className="amount">{formatCurrency(invoice.subtotal)}</div></BasicFlex>
        <BasicFlex justify="flex-end" gap="2rem"><div>Fees & Discounts:</div><div className="amount">{formatCurrency(adjustmentTotal)}</div></BasicFlex>
        <BasicFlex justify="flex-end" gap="2rem"><div>Tax:</div><div className="amount">{formatCurrency(invoice.tax)}</div></BasicFlex>
        <BasicFlex justify="flex-end" gap="2rem"><div>Total:</div><div className="amount">{formatCurrency(invoice.total)}</div></BasicFlex>
        <BasicFlex justify="flex-end" gap="2rem"><div>Amount Paid:</div><div className="amount">{formatCurrency(invoice.total_paid)}</div></BasicFlex>
        <BasicFlex justify="flex-end" gap="2rem"><div>Balance:</div><div className="amount">{formatCurrency(invoice.balance)}</div></BasicFlex>
      </SummarySection>
    </InvoiceContainer>
  )

};

export default InvoiceDisplay;